import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Parking } from 'src/app/core/models/parking.model';
import { ParkingService } from 'src/app/core/services/parking.service';

@Component({
  selector: 'app-select-parking-dialog',
  templateUrl: './select-parking-dialog.component.html',
  styleUrls: ['./select-parking-dialog.component.scss']
})
export class SelectParkingDialogComponent implements OnInit {
  @Output() onClickedConfirmButton = new EventEmitter<any>();
  parkings: Parking[];
  selectedParking;
  showSelectOption: boolean = true;

  constructor( 
    public dialogRef: MatDialogRef<SelectParkingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public parkingService: ParkingService) {
      if(data.path.includes("configs") || data.path.includes("knowledge-base") || data.path.includes("parking-info")) {
        this.showSelectOption = false;
      }
    }

  ngOnInit() {
    this.getParkings();
  }

  getParkings() {
    this.parkingService.GetAll().subscribe(parkings => {
      if (parkings) {
        this.parkings = parkings.sort((a,b) => Number(a.id) - Number(b.id));
      }
    }, error => console.error(error));
  }

  selectParking() {
    this.onClickedConfirmButton.emit(this.selectedParking);
  }
}